import { createUseStyles } from 'react-jss';

import { Breakpoint, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, colors }: ITheme) => ({
    root: {
      cursor: 'pointer',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: spacing.large,
      width: '100%',

      padding: 37,

      background: 'var(--x-bg-1)',

      border: '2px dashed var(--x-border-2)',
      borderRadius: '16px',

      '&:hover': {
        borderColor: colors.primary,
      },

      '&.hovering': {
        borderColor: colors.primary,
        background: 'var(--x-accent-1-5)',
      },
      [mediaQuery(Breakpoint.Small)]: {
        padding: [48, 8],
      },
    },
    input: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      borderWidth: 0,
    },
  }),
  {
    name: 'upload-area',
  },
);

export default useStyles;
